// Strategy
import filterTagStrategy from './filterTagStrategy';

// Components
import FilterTagComponent from './FilterTagComponent';

// Components
export default () => ({
    decorators: [
        {
            strategy: filterTagStrategy,
            component: FilterTagComponent,
        },
    ],
});
